import { ChatTag } from '@/models/chattingUI/messageEditor/tags/types'
import { ChatTagItem } from '@/modules/chatting/ui/chat-window/chat-tag-item.tsx'

interface Props {
  tags: ChatTag[]
  onRemove: (tagId: number) => void
}

export const ChatTags = ({ tags, onRemove }: Props) => {
  return (
    <div className="no-scrollbar flex items-center gap-2.5 overflow-y-auto">
      {tags.map((t) => (
        <ChatTagItem
          onRemove={onRemove}
          item={t}
          key={t.id}
        />
      ))}
    </div>
  )
}
